import StudentPersonalIrosPage from "./StudentPersonalIrosPage";
export default StudentPersonalIrosPage;